import { render, staticRenderFns } from "./xindian.vue?vue&type=template&id=898c3e02&scoped=true&"
import script from "./xindian.vue?vue&type=script&lang=ts&"
export * from "./xindian.vue?vue&type=script&lang=ts&"
import style0 from "./xindian.vue?vue&type=style&index=0&id=898c3e02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898c3e02",
  null
  
)

export default component.exports